export default __webpack_public_path__ + "static/object-larger-dont-51ca97911a0e432925d761af1a8018e05c719062c0c5cb5ccdf39afdda6946bd.png";